import { useCallback, type RefObject } from 'react'

/**
 * Opens the workspace-item picker when a member types an @ mention. The
 * caller still owns the field value, keeping this deliberately independent
 * from draft persistence and picker selection mechanics.
 */
export const useMentionOnAt = (
  ref: RefObject<HTMLTextAreaElement | null>,
  onOpen: () => void,
) => useCallback((value: string) => {
  if (value.endsWith('@') && ref.current === document.activeElement) onOpen()
}, [onOpen, ref])
